export default "__VITE_ASSET__BnZKQ_SI__"